import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Collapse, Button, Tabs, Select, Radio, Checkbox, message} from 'antd'
import Editor from '../../../utils/brace'
import TargetDataForm from './targetDataForm'
import OutputSetForm from './outputSetForm'
import FieldSetForm from './fieldSetForm'
import TableStructure from './TableStructure'
import ChooseFile from './ChooseFile'
import ApiManagementAPI from '../../../apis/apiManagementAPI'
import {EyeOutlined} from '@ant-design/icons'
import GroovyModal from './groovyModal'
import alertMessage from '../../../utils/alertMessage'
import {Base64} from 'js-base64'
import {withTranslation} from 'react-i18next'

const {Panel} = Collapse
const {TextArea} = Input
const {TabPane} = Tabs

@inject('apiManagementStore')
@observer
class FormModal extends Component {
  state = {
    verVisible: false,
    isShow: true,
    current: '0',
    dataBody: null,
    sampleData: null,
    sqlScript: null,
    // fieldInfos: [],
    // dataPaths: [],
    // outputValues: [],
    fieldInfos: null,
    dataPaths: null,
    outputValues: null,
    defaultDirection: 'OUTBOUND',
    baseData: {},
    custList: [],
    businessTypeList: [],
    groovyList: [],
    ingestionList: [],
    operationList: [],
    groovyId: '',
    curDataIngestion: '',
    curIngestionId: '',
    sqlType: '',
    script: null,
    curDataType: '',
    fileType: '',
    isShowTableStructure: false,
    isShowChooseFile: false,
    isSignalFile: false,
    isZip: false,
    isEmptyFile: false,
    saveLoading: false,
    scriptEditable: false,
    sqlQuery: null
  }
  formRef = React.createRef()
  editorRef1 = React.createRef()
  editorRef2 = React.createRef()
  editorRef3 = React.createRef()
  editorRef4 = React.createRef()

  componentDidMount() {
    const {title, record} = this.props
    this.getCust()
    this.getBusinessType()
    if (title === 'edit') {
      ApiManagementAPI.getDetailAction(record.id).then(res => {
        let resData = res.data.data
        let fieldSeparatorValue = resData.fieldSeparator
        let quoteCharacterValue = resData.quoteCharacter
        if (resData.fieldSeparator === ';') {
          fieldSeparatorValue = 'a'
        } else if (resData.fieldSeparator === ',') {
          fieldSeparatorValue = 'b'
        } else if (resData.fieldSeparator === '|') {
          fieldSeparatorValue = 'c'
        } else if (resData.fieldSeparator === ' ') {
          fieldSeparatorValue = 'd'
        } else if (resData.fieldSeparator === '\t') {
          fieldSeparatorValue = 'e'
        }

        if (resData.quoteCharacter === `"`) {
          quoteCharacterValue = 'e'
        } else if (resData.quoteCharacter === `'`) {
          quoteCharacterValue = 'f'
        } else if (resData.quoteCharacter === ``) {
          quoteCharacterValue = 'g'
        }
        this.formRef.current.setFieldsValue({
          direction: resData.direction,
          customer: resData.customer,
          businessType: resData.businessType,
          apiName: resData.apiName,
          apiShortName: resData.apiShortName,
          groovy: resData.groovy,
          dataIngestion: resData.dataIngestion,
          ingestionId: resData.ingestionId,
          ingestionOperationPojoId: resData.ingestionOperationPojoId,
          communication: resData.communication,
          sqlType: resData.sqlType,
          dbOperationType: resData.dbOperationType,
          description: resData.description,
          dataType: resData.dataType,
          fileNamePath: resData.fileNamePath,
          fileType: resData.fileType,
          fieldSeparator: fieldSeparatorValue,
          lineDelimiter: resData.lineDelimiter,
          quoteCharacter: quoteCharacterValue,
          keySelect: resData.keySelect,
          sqlScript: JSON.parse(JSON.stringify(res.data.data.sqlScript)),
          sheetName: resData.sheetName,
          jumpRows: resData.jumpRows,
          signalFileName: resData.signalFileName,
          zipPath: resData.zipPath,
          enableAutoCommit: resData.enableAutoCommit ? 1 : 0
        })
        this.getIngestion(resData.dataIngestion, res.curDataType)
        this.getOperationList({dataIngestion: resData.dataIngestion, ingestionId: resData.ingestionId})
        this.setState({
          dataPaths: res.data.data.dataPaths,
          defaultDirection: resData.direction,
          curDataIngestion: resData.dataIngestion,
          curIngestionId: resData.ingestionId,
          dataBody: JSON.parse(JSON.stringify(res.data.data.sampleData)),
          sampleData: JSON.parse(JSON.stringify(res.data.data.sampleData)),
          sqlScript: JSON.parse(JSON.stringify(res.data.data.sqlScript)),
          curDataType: resData.dataType,
          fileType: resData.fileType,
          isSignalFile: resData.signalFile,
          isZip: resData.zip,
          isEmptyFile: resData.emptyFile,
          sqlType: resData.sqlType,
          sqlQuery: resData.dbOperationType,
          scriptEditable: resData.sqlType === 'Automatically',
        })
        if (resData.direction === 'INBOUND') {
          this.getGroovy('INBOUNDAPI')
          this.setState({
            // dataBody: JSON.parse(JSON.stringify(res.data.data.sampleData)),
            outputValues: res.data.data.fieldSet
          })
        } else {
          this.getGroovy('OUTBOUNDAPI')
          this.setState({
            // sampleData: JSON.parse(JSON.stringify(res.data.data.sampleData)),
            fieldInfos: res.data.data.fieldSet
          })
        }
      })
    } else {
      this.getGroovy('OUTBOUNDAPI')
    }
  }

  getIngestion = (businessType, dataType) => {
    let params = {
      dataIngestion: businessType,
      dataType: dataType
    }
    ApiManagementAPI.getIngestionAction(params).then(res => {
      this.setState({
        ingestionList: res.data.data
      })
    })
  }
  getOperationList = (params) => {
    ApiManagementAPI.getOperationAction(params).then(res => {
      this.setState({
        operationList: res.data.data
      })
    })
  }
  getCust = () => {
    ApiManagementAPI.getCustAction().then(res => {
      this.setState({
        custList: res.data.data
      })
    })
  }
  getBusinessType = () => {
    ApiManagementAPI.getBusinessTypeAction().then(res => {
      this.setState({
        businessTypeList: res.data.data
      })
    })
  }
  getGroovy = (value) => {
    ApiManagementAPI.getGroovyAction(value).then(res => {
      this.setState({
        groovyList: res.data.data
      })
    })
  }
  handleOk = () => {
    this.setState({
      saveLoading: true
    })
    const {handleCancel, title, record, handleResearch, apiManagementStore} = this.props
    let params
    let flag = true
    let obj = this.state.baseData
    obj.sqlScript = Base64.encode(obj.sqlScript)
    if (this.state.defaultDirection === 'OUTBOUND') {
      const sampleData = this.state.sampleData
      let value = this.state.fieldInfos
      if (value && value.length > 1) {
        value[0].retainKey = false
      }
      params = {
        ...obj,
        sampleData: sampleData,
        fieldSet: value,
      }
      if (this.state.curDataIngestion === 'NOSEND') {
        params.communication = 'SYNCHRONOUS'
      }
    } else {
      const dataBody = this.state.dataBody
      let value = this.state.outputValues
      if (value && value.length > 1) {
        value[0].retainKey = false
      }
      params = {
        ...obj,
        sampleData: dataBody,
        dataPaths: this.state.dataPaths,
        fieldSet: value
      }
      // eslint-disable-next-line array-callback-return
      this.state.outputValues.some((item, i) => {
        if (!item.name) {
          alertMessage.error(`The name of line ${i + 1} in the Output Values Set list cannot be empty!`).then()
          flag = false
          // eslint-disable-next-line array-callback-return
          return
        }
        if (!item.path) {
          alertMessage.error(`The name of line ${i + 1} in the Output Values Set list cannot be empty!`).then()
          flag = false
          // this.$message.warn(`The path of line ${i + 1} in the Output Values Set list cannot be empty!`)

        }
      })
    }
    if (flag === true) {
      params.dboperationType = obj.dbOperationType || ''
      params.primaryKeyType = obj.primaryKeyType || ''
      params.insertSql = Base64.encode(apiManagementStore.sqlData?.insertSql || '')
      params.updateByIdSql = Base64.encode(apiManagementStore.sqlData?.updateByIdSql || '')
      params.selectCountByIdSql = Base64.encode(apiManagementStore.sqlData?.selectCountByIdSql || '')
      params.truncateSql = Base64.encode(apiManagementStore.sqlData?.truncateSql || '')

      if (title === 'edit') {
        params.id = record.id
      }
      ApiManagementAPI.addBoundAction(params).then(() => {
        handleCancel()
        handleResearch(this.state.defaultDirection)
        this.setState({
          saveLoading: false
        })
        message.success('Success!').then()
      }).catch(() => [
        this.setState({
          saveLoading: false
        })
      ])
    }
  }
  // 切换step
  onTabChange = (value) => {
    if (this.state.current === '0') {
      this.formRef.current.validateFields().then((values) => {
        this.setState({
          baseData: values,
          current: value
        })
      }).catch(err => {
        console.log(err)
      })
    } else {
      this.setState({
        current: '0'
      })
    }
  }
  handleNext = () => {
    this.formRef.current.validateFields().then((values) => {
      let newValue = values
      newValue.signalFile = this.state.isSignalFile
      newValue.zip = this.state.isZip
      newValue.emptyFile = this.state.isEmptyFile
      newValue.enableAutoCommit = values.enableAutoCommit===1

      if (newValue.zip) {
        const {fileNamePath, zipPath, fileType} = newValue
        const fileNamePathEndingWord = fileNamePath.substring(fileNamePath.length - 4, fileNamePath.length)
        const zipPathEndingWord = zipPath.substring(zipPath.length - fileType.length, zipPath.length)

        if (fileNamePathEndingWord !== '.zip') {
          return alertMessage.warning('File Path&Name must end with .zip')
        }
        if (zipPathEndingWord !== fileType) {
          return alertMessage.warning(`Zip Path must end with .${fileType}`)
        }
      }

      if (newValue.signalFile) {
        const {signalFileName} = newValue
        const signalFileEndingWord = signalFileName.substring(signalFileName.length - 4, signalFileName.length)

        if (signalFileEndingWord !== '.txt') {
          return alertMessage.warning('Signal File Name must end with .txt')
        }
      }

      if (newValue.fieldSeparator === 'a') {
        newValue.fieldSeparator = ';'
      } else if (newValue.fieldSeparator === 'b') {
        newValue.fieldSeparator = ','
      } else if (newValue.fieldSeparator === 'c') {
        newValue.fieldSeparator = '|'
      } else if (newValue.fieldSeparator === 'd') {
        newValue.fieldSeparator = ' '
      } else if (newValue.fieldSeparator === 'e') {
        newValue.fieldSeparator = '\t'
      }

      if (newValue.quoteCharacter === 'e') {
        newValue.quoteCharacter = `"`
      } else if (newValue.quoteCharacter === 'f') {
        newValue.quoteCharacter = `'`
      } else if (newValue.quoteCharacter === 'g') {
        newValue.quoteCharacter = ``
      }

      this.setState({
        baseData: newValue,
        current: '1'
      })
    }).catch(err => {
      console.log(err)
    })
  }
  handlePrev = () => {
    this.setState({
      current: '0'
    })
  }
  editorSQLChange = (data) => {
    this.setState({
      sqlScript: data
    })
  }
  editorChange = (data) => {
    this.setState({
      dataBody: data
    }, () => {
      this.targetRef.init(data)
    })
  }
  editorSampleChange = (data) => {
    this.setState({
      sampleData: data
    })
    try {
      this.fieldSetFormRef.init(data)
    } catch (e) { }
  }

  isJSON = (str) => {
    if (typeof str == 'string') {
      try {
        const obj = JSON.parse(str)
        return !!(typeof obj == 'object' && obj)

      } catch (e) {
        console.log('error：' + str + '!!!' + e)
        return false
      }
    }
  }

  onTargetChange = (value) => {
    this.setState({
      dataPaths: value
    }, () => {
      if (this.isJSON(this.state.dataBody)) {
        this.OutputSetFormRef.init()
      }
    })
  }
  onOutputSetChange = (value) => {
    this.setState({
      outputValues: value
    })
  }
  onFieldSetChange = (value) => {
    this.setState({
      fieldInfos: value
    })
  }
  onDirectionChange = (value) => {
    this.formRef.current.setFieldsValue({
      groovy: null
    })
    this.setState({
      defaultDirection: value,
      isShow: false,
      dataBody: null,
      sampleData: null,
      fieldInfos: [],
      dataPaths: [],
      outputValues: [],
    })
    if (this.state.curDataIngestion === 'NOSEND') {
      this.setState({
        curDataIngestion: ''
      })
      this.formRef.current.setFieldsValue({
        dataIngestion: ''
      })
    }
    if (value === 'INBOUND') {
      this.getGroovy('INBOUNDAPI')
    }
    if (value === 'OUTBOUND') {
      this.getGroovy('OUTBOUNDAPI')
    }
    setTimeout(() => {
      this.setState({
        isShow: true
      })
    })
  }
  onGroovyChange = (value) => {
    this.setState({
      groovyId: value
    })
  }
  onDataIngestionChange = (value) => {
    if (value && this.state.curDataType) {
      this.getIngestion(value, this.state.curDataType)
    } else {
      this.setState({
        ingestionList: []
      })
    }
    this.formRef.current.setFieldsValue({
      ingestionId: '',
      ingestionOperationPojoId: '',
      dataType: null,
      sqlScript: ''
    })
    this.setState({
      curDataIngestion: value ? value : '',
      curIngestionId: '',
      sqlScript: null,
      curDataType:''
    })
  }
  onDataTypeChange = (value) => {
    if (value && this.state.curDataIngestion) {
      this.getIngestion(this.state.curDataIngestion, value)
    } else {
      this.setState({
        ingestionList: []
      })
    }
    this.formRef.current.setFieldsValue({
      ingestionId: '',
      ingestionOperationPojoId: '',
      sqlScript: ''
    })
    this.setState({
      curDataType: value ? value : '',
      curIngestionId: ''
    })
  }

  onFileTypeChange = (value) => {
    this.setState({
      fileType: value ? value : ''
    })
  }

  onIngestionIdChange = (value) => {
    if (value) {
      this.getOperationList({dataIngestion: this.state.curDataIngestion, ingestionId: value})
    }
    this.formRef.current.setFieldsValue({
      ingestionOperationPojoId: '',
      sqlScript: ''
    })
    this.setState({
      curIngestionId: value ? value : ''
    })
  }

  handleGroovyCancel = () => {
    this.setState({
      verVisible: false
    })
  }

  handleSetState = (key, value) => {
    this.setState({
      [key]: value
    })
  }

  handleVer = () => {
    this.setState({
      groovyId: this.formRef.current.getFieldValue('groovy')
    })
    if (this.formRef.current.getFieldValue('groovy')) {
      this.setState({
        verVisible: true
      })
    }
  }

  showTableStructure = () => {
    this.setState({
      isShowTableStructure: true
    })
  }

  closeTableStructure = () => {
    this.setState({
      isShowTableStructure: false
    })
  }

  showChooseFile = () => {
    this.setState({
      isShowChooseFile: true
    })
  }

  closeChooseFile = () => {
    this.setState({
      isShowChooseFile: false
    })
  }

  getChooseFilePath = (e) => {
    this.formRef.current.setFieldsValue({
      fileNamePath: e,
    })
  }

  isSignalFileCilck = (e) => {
    this.setState({
      isSignalFile: e.target.checked
    })
    this.formRef.current.setFieldsValue({
      signalFileName: null,
    })
  }

  isZipClick = (e) => {
    this.setState({
      isZip: e.target.checked
    })
    this.formRef.current.setFieldsValue({
      zipPath: null,
    })
  }

  isEmptyFileClick = (e) => {
    this.setState({
      isEmptyFile: e.target.checked
    })
  }

  onSqlTypeChange = e => {
    this.setState({
      scriptEditable: e === 'Automatically',
      sqlType: e ? e : ''
    })
    // this.formRef.current.setFieldsValue({'sqlScript': ''})
  }

  onSqlQueryChange = e => {
    this.setState({sqlQuery: e})
    this.formRef.current.setFieldsValue({'sqlScript': ''})
  }

  generateSql = async () => {
    const {apiManagementStore, t} = this.props
    const {tableName, selectedRows, generateSql} = apiManagementStore
    const {dbOperationType, primaryKeyType = 'NONE'} = this.formRef.current.getFieldsValue(true)
    const params = {
      tableName: tableName,
      tableInfoDtos: selectedRows,
      dbOperationType,
      primaryKeyType
    }
    if (selectedRows.length <= 0) return alertMessage.warning(`${t('general.pleaseSelect')} ${t('apiManagement.tableStructure')}`)
    if (!dbOperationType) return alertMessage.warning(`${t('general.pleaseSelect')} ${t('apiManagement.sqlQuery')}`)
    if (!primaryKeyType) return alertMessage.warning(`${t('general.pleaseSelect')} ${t('apiManagement.primaryKey')}`)
    const response = await generateSql(params)

    if (response.code === 0) {
      switch (dbOperationType) {
        case 'update':
          this.formRef.current.setFieldsValue({
            'sqlScript': response?.data?.updateByIdSql
          })
          break
        case 'insertOrUpdate':
          this.formRef.current.setFieldsValue({
            'sqlScript': response?.data?.insertSql,
            'updateByIdSql': response?.data?.updateByIdSql
          })
          break
        case 'dropAndInsert':
          this.formRef.current.setFieldsValue({
            'sqlScript': response?.data?.insertSql
          })
          break
        default:
          this.formRef.current.setFieldsValue({
            'sqlScript': response?.data?.insertSql
          })
      }
    }
  }

  render() {
    const {boundVisible, handleCancel, title, t} = this.props
    const {scriptEditable, sqlScript, sqlQuery} = this.state
    return (
      <>
        <Modal
          title={title === 'edit' ? `${t(`general.edit`)} ${t(`apiManagement.connect`)}` : `${t(`general.add`)} ${t(`apiManagement.connect`)}`}
          closable={true}
          visible={boundVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width="70%"
          centered
          footer={
            this.state.current === '0' ? (
              [
                <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
                <Button key="Next" type="primary" onClick={this.handleNext}>{t(`general.next`)}</Button>,
              ]
            ) : (
              [
                <Button key="Prev" onClick={this.handlePrev}>{t(`general.prev`)}</Button>,
                <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
                <Button key="Save" type="primary" onClick={this.handleOk} loading={this.state.saveLoading}>{t(`general.save`)}</Button>,
              ]
            )
          }
        >
          <Tabs defaultActiveKey="0" activeKey={this.state.current} onChange={this.onTabChange} style={{marginBottom: '30px'}}
                className="messagesTabs">
            <TabPane tab={t(`apiManagement.basicInfo`)} key="0"></TabPane>
            <TabPane tab={t(`apiManagement.dataInfo`)} key="1"></TabPane>
          </Tabs>
          <Form ref={this.formRef} name="basic" autoComplete="off" style={{display: this.state.current !== '0' ? 'none' : ''}} layout="vertical">
            <Row wrap={true} gutter={[10, 0]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="direction" label={t(`apiManagement.direction`)} initialValue={this.state.defaultDirection}
                           rules={[
                             {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.direction`)}`},
                           ]}>
                  <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onDirectionChange} disabled={title === 'edit'}>
                    <Select.Option key="INBOUND" value="INBOUND">INBOUND</Select.Option>
                    <Select.Option key="OUTBOUND" value="OUTBOUND">OUTBOUND</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="customer" label={t(`apiManagement.customer`)}
                           rules={[
                             {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.customer`)}`},
                           ]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {this.state.custList.length > 0 ? this.state.custList.map(item => <Select.Option key={item.id}
                                                                                                     value={item.id}>{item.customer}</Select.Option>) : null}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="businessType" label={t(`apiManagement.businessType`)}
                           rules={[
                             {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.businessType`)}`},
                           ]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {this.state.businessTypeList.length > 0 ? this.state.businessTypeList.map(item => <Select.Option key={item.businessType}
                                                                                                                     value={item.businessType}>{item.businessType}</Select.Option>) : null}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item label={t(`apiManagement.connectName`)} name="apiName"
                           rules={[
                             {
                               required: true,
                               message: `${t(`general.pleaseEnter`)} ${t(`apiManagement.connectName`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             },
                           ]}
                >
                  <Input
                    placeholder={t(`general.pleaseEnter`)}
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item label={t(`apiManagement.connectShortName`)} name="apiShortName"
                           rules={[
                             {required: true, message: `${t(`general.pleaseEnter`)} ${t(`apiManagement.connectShortName`)}`},
                           ]}
                >
                  <Input
                    placeholder={t(`general.pleaseEnter`)}
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item label={t(`apiManagement.groovy`)}>
                  <Row gutter={8}>
                    <Col span={20}>
                      <Form.Item name="groovy" noStyle>
                        <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onGroovyChange} allowClear>
                          {this.state.groovyList.length > 0 ? this.state.groovyList.map(item => <Select.Option key={item.id}
                                                                                                               value={item.id}>{item.name}</Select.Option>) : null}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Button type="link" icon={<EyeOutlined/>} onClick={this.handleVer} title={t(`general.display`)}/>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="dataIngestion" label={t(`apiManagement.dataIngestion`)}
                           rules={[
                             {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.dataIngestion`)}`},
                           ]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onDataIngestionChange}>
                    <Select.Option key="DATASOURCE" value="DATASOURCE">{t(`apiManagement.dataSource`)}</Select.Option>
                    <Select.Option key="DATATARGET" value="DATATARGET">{t(`apiManagement.dataTarget`)}</Select.Option>
                    {/* {this.state.defaultDirection === 'OUTBOUND' ? (<><Select.Option key='Nosend' value='NOSEND'>Nosend</Select.Option></>) : null} */}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="dataType" label={t(`apiManagement.dataType`)}
                           rules={[
                             {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.dataType`)}`},
                           ]}>
                  {
                    this.state.curDataIngestion === 'DATASOURCE' ?
                      <Select placeholder="Please select ..." allowClear onChange={this.onDataTypeChange}>
                        <Select.Option key="HTTP" value="HTTP">HTTP</Select.Option>
                        <Select.Option key="DB" value="DB">DB</Select.Option>
                        <Select.Option key="SFTP" value="SFTP">SFTP</Select.Option>
                        <Select.Option key="Blob" value="Blob">Blob</Select.Option>
                      </Select> :
                      this.state.curDataIngestion === 'DATATARGET' ?
                        <Select placeholder="Please select ..." allowClear onChange={this.onDataTypeChange}>
                          <Select.Option key="HTTP" value="HTTP">HTTP</Select.Option>
                          <Select.Option key="DB" value="DB">DB</Select.Option>
                          <Select.Option key="SFTP" value="SFTP">SFTP</Select.Option>
                          <Select.Option key="Blob" value="Blob">Blob</Select.Option>
                        </Select> :
                        <Select placeholder={t(`general.pleaseSelect`)} disabled allowClear onChange={this.onDataTypeChange}>
                        </Select>
                  }
                </Form.Item>
              </Col>

              {
                this.state.curDataIngestion !== 'NOSEND' ? (
                  <>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="ingestionId" label={t(`apiManagement.ingestionName`)}
                                 rules={[
                                   {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.ingestionName`)}`},
                                 ]}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.curDataIngestion === ''} showSearch
                                onChange={this.onIngestionIdChange} optionFilterProp="children" filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                          {this.state.ingestionList.length > 0 ? this.state.ingestionList.map(item => <Select.Option key={item.id}
                                                                                                                     value={item.id}>{item.name}</Select.Option>) : null}
                        </Select>
                      </Form.Item>
                    </Col>
                    {this.state.curDataType === 'HTTP' ?
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="ingestionOperationPojoId" label={t(`apiManagement.operation`)}
                                   rules={[
                                     {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.operation`)}`},
                                   ]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear
                                  disabled={this.state.curDataIngestion === '' || this.state.curIngestionId === ''}>
                            {this.state.operationList.length > 0 ? this.state.operationList.map(item => <Select.Option key={item.id}
                                                                                                                       value={item.id}>{item.operationName}</Select.Option>) : null}
                          </Select>
                        </Form.Item>
                      </Col> : null
                    }
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="communication" label={t(`apiManagement.communication`)}
                                 rules={[
                                   {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.communication`)}`},
                                 ]}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                          <Select.Option key="SYNCHRONOUS" value="SYNCHRONOUS">Synchronous</Select.Option>
                          <Select.Option key="ASYNCHRONOUS" value="ASYNCHRONOUS">Asynchronous</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </>
                ) : null
              }
              {
                this.state.curDataType === 'DB' ? (
                  <>
                    {
                      this.state.curDataIngestion === 'DATATARGET' ?
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="sqlType" label={t(`apiManagement.sqlType`)}>
                              <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onSqlTypeChange} allowClear>
                                <Select.Option key="Automatically" value="Automatically">{t(`apiManagement.automatically`)}</Select.Option>
                                <Select.Option key="Input" value="Input">{t(`apiManagement.input`)}</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          {
                            this.state.defaultDirection === 'INBOUND'
                              ? <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                <Form.Item name="enableAutoCommit" label={t(`apiManagement.enableAutoCommit`)} initialValue={1}>
                                  <Select placeholder={t(`general.pleaseSelect`)}>
                                    <Select.Option key="true" value={1}>是</Select.Option>
                                    <Select.Option key="false" value={0}>否</Select.Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              : null
                          }
                          {
                            scriptEditable ?
                              <>
                                <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                  <Form.Item name="dbOperationType" label={t(`apiManagement.sqlQuery`)}>
                                    <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onSqlQueryChange} allowClear>
                                      <Select.Option key="insert" value="insert">Insert</Select.Option>
                                      <Select.Option key="update" value="update">Update</Select.Option>
                                      {/*<Select.Option key="insertOrUpdate" value="insertOrUpdate">InsertOrUpdate</Select.Option> */}
                                      <Select.Option key="dropAndInsert" value="dropAndInsert">DropAndInsert</Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                                {/* <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                  <Form.Item name="primaryKeyType" label={t(`apiManagement.primaryKey`)}>
                                    <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                                      <Select.Option key="UUID" value="UUID">UUID</Select.Option>
                                      <Select.Option key="snowFlake" value="snowFlake">SnowFlake ID</Select.Option>
                                      <Select.Option key="AUTO" value="AUTO">AUTO</Select.Option>
                                      <Select.Option key="NONE" value="NONE">NONE</Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col> */}
                              </> : null
                          }
                        </> : null
                    }
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="tableStructure" label={t(`apiManagement.tableStructure`)}>
                        <Button type="primary" onClick={this.showTableStructure}
                                disabled={
                                  (!(this.state.curIngestionId && this.state.curDataIngestion) && this.state.curDataIngestion === 'DATASOURCE') ||
                                  (!(this.state.curIngestionId && this.state.curDataIngestion && this.state.sqlType && this.state.sqlQuery) && this.state.curDataType === 'DB' && this.state.curDataIngestion === 'DATATARGET')}>{t(`general.view`)}</Button>
                      </Form.Item>
                    </Col>
                    {/* {
                      this.state.curDataIngestion === 'DATATARGET' ?
                        <>
                          {
                            scriptEditable ?
                              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                <Form.Item name="generateSql" label=" ">
                                  <Button type="primary" onClick={this.generateSql}>{t(`apiManagement.generateSql`)}</Button>
                                </Form.Item>
                              </Col> : null
                          }
                        </> : null
                    } */}
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                      <Form.Item name="sqlScript" label={t(`apiManagement.sqlScript`)}
                                 rules={[
                                   {required: !scriptEditable, message: `${t(`general.pleaseEnter`)} ${t(`apiManagement.sqlScript`)}`},
                                 ]}>
                        <Editor
                          ref={this.editorRef4}
                          mode="json"
                          width="100%"
                          height="300px"
                          theme="chrome"
                          enableBasicAutocompletion={false}
                          enableLiveAutocompletion={false}
                          enableSnippets={false}
                          enableEmmet={false}
                          useElasticTabstops={false}
                          setOptions={{useWorker: false}}
                          fontSize="16px"
                          value={sqlScript}
                          readOnly={scriptEditable}
                          onChange={this.editorSQLChange}
                        ></Editor>
                      </Form.Item>
                    </Col>
                    {
                      sqlQuery === 'insertOrUpdate' ?
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                          <Form.Item name="updateByIdSql" label={t(`apiManagement.updateScript`)}>
                            <Editor
                              ref={this.editorRef4}
                              mode="json"
                              width="100%"
                              height="300px"
                              theme="chrome"
                              enableBasicAutocompletion={false}
                              enableLiveAutocompletion={false}
                              enableSnippets={false}
                              enableEmmet={false}
                              useElasticTabstops={false}
                              setOptions={{useWorker: false}}
                              fontSize="16px"
                              readOnly={scriptEditable}
                              onChange={this.editorSQLChange}
                            ></Editor>
                          </Form.Item>
                        </Col> : null
                    }
                  </>
                ) : this.state.curDataType === 'SFTP' || this.state.curDataType === 'Blob' ? (
                  <>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item label={t(`apiManagement.filePathName`)} name="fileNamePath"
                                 style={{display: 'inline-flex', width: 'calc(100% - 90px)'}}
                                 rules={[
                                   {required: true, message: `${t(`general.pleaseEnter`)} ${t(`apiManagement.filePathName`)}`},
                                 ]}
                      >
                        <Input
                          // style={{ width: 'calc(100% - 90px)' }}
                          placeholder={t(`general.pleaseEnter`)}
                          allowClear/>
                      </Form.Item>
                      <Button type="primary" style={{marginTop: 30}} onClick={this.showChooseFile}
                              disabled={(!(this.state.curIngestionId && this.state.curDataIngestion))}>{t(`general.choose`)}</Button>
                    </Col>
                    {
                      this.state.curDataIngestion === 'DATASOURCE' ?
                        <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                          <Form.Item label={t(`apiManagement.jumpRows`)} name="jumpRows"
                                     rules={[
                                       {
                                         required: true,
                                         message: `${t(`general.pleaseEnter`)} ${t(`apiManagement.jumpRows`)} ${t(`general.withNumbers`)}`,
                                         pattern: new RegExp(/^[0-9]*$/)
                                       },
                                     ]}
                          >
                            <Input
                              placeholder={t(`general.pleaseEnter`)}
                              allowClear/>
                          </Form.Item>
                        </Col> : null
                    }
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="keySelect" label={t(`apiManagement.fileKeySelect`)}
                                 rules={[
                                   {required: true, message: `${t(`general.pleaseChoose`)} ${t(`apiManagement.fileKeySelect`)}`},
                                 ]}>
                        <Radio.Group style={{display: 'flex'}}>
                          <Radio value={'1'}>First column</Radio>
                          <Radio value={'2'}>No column</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {
                      this.state.curDataType === 'SFTP' || this.state.curDataType === 'Blob' ?
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="signalFile" label={t(`apiManagement.signalFile`)}>
                              <Checkbox onChange={this.isSignalFileCilck} checked={this.state.isSignalFile}></Checkbox>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="signalFileName" label={t(`apiManagement.signalFileName`)} rules={[
                              {
                                required: this.state.isSignalFile,
                                message: `${t(`general.pleaseEnter`)} ${t(`apiManagement.signalFileName`)}`,
                                pattern: new RegExp(/^\S+(\s+\S+)*$/)
                              }
                            ]}>
                              <Input
                                placeholder={t(`general.pleaseEnter`)}
                                allowClear
                                disabled={!this.state.isSignalFile}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="zip" label={t(`apiManagement.zip`)}>
                              <Checkbox onChange={this.isZipClick} checked={this.state.isZip}></Checkbox>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="zipPath" label={t(`apiManagement.zipPath`)} rules={[
                              {
                                required: this.state.isZip,
                                message: `${t(`general.pleaseEnter`)} ${t(`apiManagement.zipPath`)}`,
                                pattern: new RegExp(/^\S+(\s+\S+)*$/)
                              }
                            ]}>
                              <Input
                                placeholder={t(`general.pleaseEnter`)}
                                allowClear
                                disabled={!this.state.isZip}
                              />
                            </Form.Item>
                          </Col>
                        </>
                        : null
                    }

                    {
                      this.state.curDataIngestion === 'DATATARGET' && (this.state.curDataType === 'SFTP' || this.state.curDataType === 'Blob') ?
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="emptyFile" label={t(`apiManagement.emptyFile`)}>
                              <Checkbox onChange={this.isEmptyFileClick} checked={this.state.isEmptyFile}></Checkbox>
                            </Form.Item>
                          </Col>
                        </> : null
                    }

                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="fileType" label={t(`apiManagement.fileType`)}
                                 rules={[
                                   {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.fileType`)}`},
                                 ]}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onFileTypeChange}>
                          <Select.Option key="xls" value="xls">xls</Select.Option>
                          <Select.Option key="xlsx" value="xlsx">xlsx</Select.Option>
                          <Select.Option key="csv" value="csv">csv</Select.Option>
                          <Select.Option key="txt" value="txt">txt</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    {
                      this.state.fileType === 'xls' || this.state.fileType === 'xlsx' ?
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="sheetName" label={t(`apiManagement.sheetName`)}
                                       rules={[
                                         {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.sheetName`)}`},
                                       ]}>
                              <Input
                                placeholder={t(`general.pleaseSelect`)}
                                allowClear
                              />
                            </Form.Item>
                          </Col>
                        </> : null
                    }
                    {
                      this.state.fileType === 'csv' || this.state.fileType === 'txt' ?
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="fieldSeparator" label={t(`apiManagement.fieldSeparator`)}
                                       rules={[
                                         {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.fieldSeparator`)}`},
                                       ]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                                <Select.Option key="a" value="a">;</Select.Option>
                                <Select.Option key="b" value="b">,</Select.Option>
                                <Select.Option key="c" value="c">|</Select.Option>
                                <Select.Option key="d" value="d">Space</Select.Option>
                                <Select.Option key="e" value="e">Tab</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="lineDelimiter" label={t(`apiManagement.lineDelimiter`)}
                                       rules={[
                                         {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.lineDelimiter`)}`},
                                       ]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                                <Select.Option key="CRLF" value="CRLF">CRLF</Select.Option>
                                <Select.Option key="LF" value="LF">LF</Select.Option>
                                <Select.Option key="CR" value="CR">CR</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="quoteCharacter" label={t(`apiManagement.quoteCharacter`)}
                                       rules={[
                                         {required: true, message: `${t(`general.pleaseSelect`)} ${t(`apiManagement.quoteCharacter`)}`},
                                       ]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                                <Select.Option key="e" value="e">"</Select.Option>
                                <Select.Option key="f" value="f">'</Select.Option>
                                <Select.Option key="g" value="g">None</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </> : null
                    }
                  </>
                ) : null
              }

              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="description" label={t(`apiManagement.description`)}>
                  <TextArea rows={3} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Collapse defaultActiveKey={['1', '2', '3']} style={{display: this.state.current === '0' ? 'none' : ''}}>
            {
              this.state.defaultDirection === 'INBOUND' ?
                (
                  <>
                    <Panel header={t(`apiManagement.sampleData`)} key="1">
                      {
                        this.state.isShow ? (
                          <Editor
                            ref={this.editorRef1}
                            mode="json"
                            width="100%"
                            height="300px"
                            theme="chrome"
                            enableBasicAutocompletion={false}
                            enableLiveAutocompletion={false}
                            enableSnippets={false}
                            enableEmmet={false}
                            useElasticTabstops={false}
                            setOptions={{useWorker: false}}
                            fontSize="16px"
                            value={this.state.dataBody ? this.state.dataBody : null}
                            readonly={false}
                            onChange={this.editorChange}
                          ></Editor>
                        ) : null
                      }
                    </Panel>
                    <Panel header={t(`apiManagement.tarDataPathInfo`)} key="2">
                      <>
                        {
                          // (title === 'edit' && this.state.dataPaths.length) ? (
                          (title === 'edit' && this.state.dataPaths) ? (
                            <TargetDataForm onRef={(ref) => { this.targetRef = ref }} dataBody={this.state.dataBody} value={this.state.dataPaths}
                                            onChange={this.onTargetChange}></TargetDataForm>
                          ) : null
                        }
                        {
                          (title === 'add') ? (
                            <TargetDataForm onRef={(ref) => { this.targetRef = ref }} dataBody={this.state.dataBody} value={[]}
                                            onChange={this.onTargetChange}></TargetDataForm>
                          ) : null
                        }
                      </>
                    </Panel>
                    <Panel header={t(`apiManagement.outputValuesSet`)} key="3">
                      <>
                        {
                          // (title === 'edit' && this.state.outputValues.length) ? (
                          (title === 'edit' && this.state.outputValues) ? (
                            <OutputSetForm onRef={(ref) => { this.OutputSetFormRef = ref }} dataBody={this.state.dataBody}
                                           dataPaths={this.state.dataPaths} value={this.state.outputValues}
                                           onChange={this.onOutputSetChange}></OutputSetForm>
                          ) : null
                        }
                        {
                          (title === 'add') ? (
                            <OutputSetForm onRef={(ref) => { this.OutputSetFormRef = ref }} dataBody={this.state.dataBody}
                                           dataPaths={this.state.dataPaths} value={[]} onChange={this.onOutputSetChange}></OutputSetForm>
                          ) : null
                        }
                      </>
                    </Panel>
                  </>
                ) : (
                  <>
                    <Panel header={t(`apiManagement.sampleData`)} key="1">
                      {
                        this.state.isShow ? (
                          <Editor
                            ref={this.editorRef2}
                            mode="json"
                            width="100%"
                            height="300px"
                            theme="chrome"
                            enableBasicAutocompletion={false}
                            enableLiveAutocompletion={false}
                            enableSnippets={false}
                            enableEmmet={false}
                            useElasticTabstops={false}
                            setOptions={{useWorker: false}}
                            fontSize="16px"
                            value={this.state.sampleData ? this.state.sampleData : null}
                            onChange={this.editorSampleChange}
                          ></Editor>
                        ) : null
                      }
                    </Panel>
                    <Panel header={t(`apiManagement.field`)} key="2">
                      <>
                        {
                          // (title === 'edit' && this.state.fieldInfos.length) ? (
                          (title === 'edit' && this.state.fieldInfos) ? (
                            <FieldSetForm onRef={(ref) => { this.fieldSetFormRef = ref }} sampleData={this.state.sampleData}
                                          value={this.state.fieldInfos} onChange={this.onFieldSetChange}></FieldSetForm>
                          ) : null
                        }
                        {
                          (title === 'add') ? (
                            <FieldSetForm onRef={(ref) => { this.fieldSetFormRef = ref }} sampleData={this.state.sampleData} value={[]}
                                          onChange={this.onFieldSetChange}></FieldSetForm>
                          ) : null
                        }
                      </>
                    </Panel>
                  </>
                )
            }
          </Collapse>
        </Modal>
        {this.state.verVisible ? <GroovyModal
          verVisible={this.state.verVisible}
          handleCancel={this.handleGroovyCancel}
          id={this.state.groovyId}
          ref={this.editorRef3}
          state={this.state}
          handleSetState={this.handleSetState}
        /> : null}

        {
          this.state.isShowTableStructure ?
            <TableStructure canSelect={scriptEditable} dataIngestion={this.state.curDataIngestion} ingestionId={this.state.curIngestionId}
                            closeTableStructure={this.closeTableStructure} generateSql={this.generateSql}/> : null
        }
        {
          this.state.isShowChooseFile ?
            <ChooseFile dataIngestion={this.state.curDataIngestion} ingestionId={this.state.curIngestionId} closeChooseFile={this.closeChooseFile}
                        dataType={this.state.curDataType} setPath={this.getChooseFilePath}/> : null
        }
      </>
    )
  }
}

export default withTranslation()(FormModal)
